import FaqAccordion from './FaqAccordion'

export default FaqAccordion
